import { Observable } from 'rxjs';
import {
  ApiService,
  GET_GAME_INVITATION_CANDIDATES_PATH,
  GetGameInvitationCandidatesPathParams,
  GetGameInvitationCandidatesResponse,
  REJECT_GAME_INVITATION_PATH,
  RejectGameInvitationPathParams,
  SEND_GAME_INVITATIONS_PATH,
  SendGameInvitationsBody,
  SendGameInvitationsPathParams,
  SendGameInvitationsResponse
} from '@core-http';

export class InvitationsService extends ApiService {
  getList(pathParams: GetGameInvitationCandidatesPathParams): Observable<GetGameInvitationCandidatesResponse> {
    const path: string = this.fillPathParams(GET_GAME_INVITATION_CANDIDATES_PATH, pathParams);

    return this.httpClient.get<GetGameInvitationCandidatesResponse>(`${this.env.apiUrl}${path}`);
  }

  invite(
    pathParams: SendGameInvitationsPathParams,
    payload: SendGameInvitationsBody
  ): Observable<SendGameInvitationsResponse> {
    const path: string = this.fillPathParams(SEND_GAME_INVITATIONS_PATH, pathParams);

    return this.httpClient.post<SendGameInvitationsResponse>(`${this.env.apiUrl}${path}`, payload);
  }

  decline(pathParams: RejectGameInvitationPathParams): Observable<void> {
    const path: string = this.fillPathParams(REJECT_GAME_INVITATION_PATH, pathParams);

    return this.httpClient.delete<void>(`${this.env.apiUrl}${path}`);
  }
}
